var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g({tag:"component",attrs:{"context":_vm.context,"settings":_vm.settings,"runtime-state":_vm.runtimeState}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }